import React from 'react';

import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { XMarkIcon } from '@heroicons/react/20/solid';

const RegistrationUsp = ({ onClose }: { onClose: () => void }) => {
  const locale = useSelector(selectLocale);

  return (
    <div className="flex items-center justify-between bg-blue-medium py-3 px-4 rounded-t-lg sm:py-4">
      <span
        className={classNames('text-white text-sm max-w-[240px] sm:!max-w-fit', {
          '!max-w-[260px]': locale === 'ca-fr',
        })}
      >
        <FormattedMessage
          id="registration.ontario.usp"
          values={{
            b: str => <span className="font-bold">{str}</span>,
          }}
        />
      </span>
      <XMarkIcon className="w-8 h-auto text-white/70 cursor-pointer" onClick={onClose} />
    </div>
  );
};

export default RegistrationUsp;
